import { Calendar } from "@fullcalendar/core"
import { format } from "date-fns"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from '@fullcalendar/interaction'
import Alpine from "../alpine.js"

Alpine.data("availabilityCalendar", ({ source }) => ({
  source,
  calendar: null,
  neweventtitle: null,
  neweventstart: null,
  neweventend: null,
  modalSrc: null,
  init() {
    this.$watch('open', (val) => { if (!val) { this.modalSrc = null } })
    this.calendar = new Calendar(this.$refs.calendar, {
      plugins: [dayGridPlugin, interactionPlugin],
      headerToolbar: {
        start: "prev",
        center: "title",
        end: "next"
      },
      height: "auto",
      selectable: false,
      defaultAllDay: false,
      initialView: "dayGridMonth",
      initialDate: format(new Date(), "yyyy-MM-dd"),
      events: this.source,
      dateClick: (info) => {
        this.modalSrc = `/appointment_windows/new?appointment_window[begins_at]=${info.dateStr}T08:00:00&appointment_window[ends_at]=${info.dateStr}T08:30:00`
        this.open = true
      },
      eventContent (info) {
        return {
          html: `
            <div style="font-size: 0.875rem; background-color: ${info.backgroundColor}; width: 100%; border-radius: 0.25rem; padding: 0.25rem; color: #ffffff; overflow: hidden;">
              <strong>${info.timeText}</strong> ${info.event.title}
            </div>`
        };
      },
      eventClick: (info) => {
        this.modalSrc = `/appointment_windows/${info.event.id}/edit`
        this.open = true
      },
      views: {
        listWeek: { buttonText: "week" }
      },
      businessHours: {
        dow: [0, 1, 2, 3, 4, 5, 6],
        start: "08:00",
        end:   "20:00"
      },
      slotMinTime: '06:00:00',
      slotMaxTime: '21:00:00',
      slotDuration: '00:10:00'
    })
    this.calendar.render()
  }
}))
